import { Resource } from '../Resource';
import { apiVersion } from '../apiVersion';
const rootPath = 'oad/weephyt';
/**
 * Return the treatment type associated to the y inside the Raw response
 * @param y
 */
export const mapYToTreatmentType = (y) => {
    switch (y) {
        case 1:
            return 'contactHerbicides';
        case 2:
            return 'systemicHerbicides';
        case 3:
            return 'rootAndAntiGerminativeHerbicides';
        case 4:
            return 'fungicides';
        default:
            return 'unknownType';
    }
};
/**
 * Return the flag associated to a value
 * @param value number from 0 to 2
 */
export const mapValueToFlag = (value) => {
    switch (value) {
        case 0:
            return 'bad';
        case 1:
            return 'medium';
        case 2:
            return 'good';
        default:
            return undefined;
    }
};
/**
 * Return the color associated to the given flag
 * @param flag we want the associated color of
 */
export const mapFlagToColor = (flag) => {
    switch (flag) {
        case 'bad':
            return '#FC7E7E';
        case 'medium':
            return '#DDEB94';
        case 'good':
            return '#80CE9E';
        default:
            return '#C4C4C4';
    }
};
/**
 * Transforms a RawWeephytDataPoint into a WeephytDataPoint
 * @param rawResult
 */
export const toReadableDataPoint = (rawPoint) => ({
    delay_without_rain: {
        value: rawPoint.delay_without_rain,
        flag: rawPoint.delay_without_rain_flag
    },
    FXY: {
        value: rawPoint.FXY,
        flag: rawPoint.FXY_flag
    },
    T: {
        value: rawPoint.T,
        flag: rawPoint.T_flag
    },
    U: {
        value: rawPoint.U,
        flag: rawPoint.U_flag
    }
});
/**
 * Transforms a raw results into a result with information we care about
 */
export const toReadableResult = (rawResult) => ({
    data: toReadableDataPoint(rawResult.data),
    flag: mapValueToFlag(rawResult.value),
    x: rawResult.x,
    y: rawResult.y
});
const weephyt = Resource((requesterBuilder) => ({
    result: (query) => requesterBuilder({
        path: `${rootPath}/result`,
        requestCtx: {
            params: {
                query: {
                    plot: query?.plotId,
                    station: query?.stationId,
                    since: query?.since,
                    before: query?.before
                }
            },
            transform: (results) => results ? results.map((res) => res.map(toReadableResult)) : [],
            ...apiVersion[1.1]
        }
    })
}));
export default weephyt;
